import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=1c6611fe&"
import script from "./TableComponent.vue?vue&type=script&lang=js&"
export * from "./TableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6611fe')) {
      api.createRecord('1c6611fe', component.options)
    } else {
      api.reload('1c6611fe', component.options)
    }
    module.hot.accept("./TableComponent.vue?vue&type=template&id=1c6611fe&", function () {
      api.rerender('1c6611fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/TableComponent.vue"
export default component.exports